import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { BibleAura } from '../components/BibleAura';
import { BibleReveal } from '../components/BibleReveal';
import { BibleCover } from '../components/BibleCover';
import { BibleVsl } from '../components/BibleVsl';
import { BibleProducts } from '../components/BibleProducts';
import { BibleTestimonials } from '../components/BibleTestimonials';
import { BibleFaq } from '../components/BibleFaq';
import { BibleStickyBar } from '../components/BibleStickyBar';
import { BibleLiveViewers } from '../components/BibleLiveViewers';
import { BibleSalesToast } from '../components/BibleSalesToast';
import { BIBLE_PRIMARY_CTA_ID, useBibleCheckout } from '../hooks/useBibleCheckout';
import { bibleConfig } from '../data/bibleConfig';
import { safeUrl } from '../utils/safeUrl';
import { scheduleMetaPixel } from '../utils/metaPixel';
export function BiblePage() {
  const {
    purchaseHref,
    secondaryHref,
    noticeVisible,
    handlePurchaseClick,
    handleSecondaryClick
  } = useBibleCheckout();
  useEffect(() => scheduleMetaPixel(), []);
  const supportUrl = safeUrl(bibleConfig.supportUrl, true);
  const privacyUrl = safeUrl(bibleConfig.privacyUrl);
  const termsUrl = safeUrl(bibleConfig.termsUrl);
  return <div className="bible-body relative min-h-screen w-full overflow-x-hidden bg-[#0b0b0e] text-[#f7f2e8]" data-id="element-306" data-mp="2v9oedo6uvbov">
      <BibleAura data-id="element-307" data-mp="23gnys8ymue2w" />

      <a href="#contenido" className="absolute -top-24 left-2 z-50 bg-[#0b0b0e] p-2.5 focus:top-2.5" data-id="element-308" data-mp="23g5t6lq2ynib">
        Saltar al contenido
      </a>

      <div className="relative z-10 border-b border-[#2c2a30] px-5 py-3 text-center text-[12px] tracking-[0.08em] text-[#e9c769]" data-id="element-309" data-mp="1yjnvg5t63pfh">
        GUÍAS DIGITALES + ACCESO A SKOOL · PAGO ÚNICO DE $11.99
      </div>

      <div className="relative z-10 mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-310" data-mp="27klyakrvdqwh">
        <header className="flex items-center justify-between gap-5 py-5 md:py-[26px]" data-id="element-311" data-mp="3ixg2rq5o7f6i">
          <span className="text-[10px] font-extrabold leading-[1.3] tracking-[0.15em] md:text-[12px]" data-id="element-312" data-mp="3izsgts8b55ea">
            START LAUNCHING
            <br data-id="element-313" data-mp="2lilbb14hogld" />
            CREATIVES
          </span>
          <nav aria-label="Navegación principal" className="flex gap-3.5 text-[12px] text-[#beb9b0] md:gap-6 md:text-[13px]" data-id="element-314" data-mp="2ll7j91vaky44">
            <a href="#materiales" className="hidden no-underline transition-colors hover:text-[#e9c769] min-[381px]:inline" data-id="element-315" data-mp="2uiqa4mvma6nx">
              Qué incluye
            </a>
            <a href="#preguntas" className="no-underline transition-colors hover:text-[#e9c769]" data-id="element-316" data-mp="21vx3xozgkf6j">
              Preguntas
            </a>
          </nav>
        </header>
      </div>

      <main id="contenido" className="relative z-10" data-id="element-317" data-mp="2bm891euvouf0">
        {/* HERO */}
        <section className="bg-[radial-gradient(ellipse_at_80%_30%,#42301940,transparent_62%)] pb-12 pt-6 md:pb-[74px] md:pt-[42px]" data-id="element-318" data-mp="1e4ro39tipmw8">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-319" data-mp="1j2jiqbljrn44">
            <div className="grid items-center gap-7 md:grid-cols-[1.4fr_0.8fr] md:gap-[70px]" style={{
            perspective: '1400px'
          }} data-id="element-320" data-mp="1bj0p7beogbha">
              <div data-id="element-321" data-mp="11lm8rbsr7moz">
                <motion.p initial={{
                opacity: 0,
                y: 14
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.5
              }} className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-322" data-mp="11l49056vuqcb">
                  The Visual Disruption Bible 2.0
                </motion.p>
                <motion.h1 initial={{
                opacity: 0,
                y: 26
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 0.08,
                ease: [0.22, 1, 0.36, 1]
              }} className="bible-serif mb-6 text-[clamp(34px,5.1vw,65px)]" data-id="element-323" data-mp="ixh9agj4qnvz">
                  La idea está en tu cabeza.
                  <br data-id="element-324" data-mp="24ywahkf3unfq" />
                  <em className="bible-em" data-id="element-325" data-mp="24yeaccpbnp2j">
                    Aprende a convertirla en instrucciones para la IA.
                  </em>
                </motion.h1>
                <motion.p initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.7,
                delay: 0.18
              }} className="max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-326" data-mp="292c5kcbj0fqb">
                  Dale dirección a tus imágenes y videos: define la escena, la
                  luz, la cámara y la secuencia con guías escritas y ejemplos que
                  puedes adaptar a tu marca.
                </motion.p>
                <motion.p initial={{
                opacity: 0,
                y: 18
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.7,
                delay: 0.26
              }} className="mt-4 text-[#beb9b0]" data-id="element-327" data-mp="1h8tmpgi843mx">
                  Para creadores y emprendedores que ya probaron la IA y quieren
                  dejar de improvisar cada prompt.
                </motion.p>
                <div className="mt-6 flex flex-wrap gap-2.5" data-id="element-328" data-mp="3gszqegp81r70">
                  {['6 PDF descargables', 'Acceso a Skool', 'Garantía de 7 días'].map((chip, index) => <motion.span key={chip} initial={{
                  opacity: 0,
                  y: 14
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.5,
                  delay: 0.34 + index * 0.08
                }} className="rounded-full border border-[#2c2a30] px-3 py-1.5 text-[12px] transition-colors hover:border-[#7b663b]" data-id="element-329" data-mp="3pqs6hn2rp2vg" data-mpi={index}>
                      {chip}
                    </motion.span>)}
                </div>
              </div>

              <BibleCover asset="bible" lines={['VISUAL', 'DISRUPTION', 'BIBLE 2.0']} note="GUÍA DIGITAL · EDICIÓN EN PDF" eager className="bible-float-3d mx-auto mt-2.5 w-[min(260px,70%)] shadow-[0_24px_80px_#0008] md:mt-0 md:w-full" data-id="element-330" data-mp="2f3cqcdsl44jj" />
            </div>

            <BibleReveal className="mx-auto mt-10 max-w-[880px] md:mt-[60px]" data-id="element-331" data-mp="rz35ibcfl0dc">
              <p className="mb-4 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-332" data-mp="x08zechtutog">
                Mira cómo se conecta una idea con un prompt
              </p>
              <BibleVsl data-id="element-333" data-mp="15zdzhn91ev2q" />
              <p className="mt-3.5 text-center text-[12px] text-[#beb9b0]" data-id="element-334" data-mp="15yupcspmpaz9">
                Ejemplos de creación con IA. Los resultados dependen de la
                herramienta, las referencias y los ajustes realizados.
              </p>
            </BibleReveal>
          </div>
        </section>

        {/* 01 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-335" data-mp="1kqwm43wejnv2">
          <div className="mx-auto grid w-[calc(100%-36px)] max-w-[1120px] items-start gap-7 md:w-[calc(100%-48px)] md:grid-cols-[1.2fr_1fr] md:gap-[65px]" data-id="element-336" data-mp="1orggizplcddi">
            <BibleReveal data-id="element-337" data-mp="357ciecn2fbq1">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-338" data-mp="3561e8bppk1ye">
                01 / El punto de partida
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-339" data-mp="2v8ws2bvv46hl">
                Sabes qué quieres ver.
                <br data-id="element-340" data-mp="3swyir3f6bwzm" />
                Pero el resultado se siente{' '}
                <em className="bible-em" data-id="element-341" data-mp="3nxlt6awx4btc">lejos de tu idea.</em>
              </h2>
              <p className="text-[#beb9b0]" data-id="element-342" data-mp="3nzosjljynhaq">
                Imaginas un producto flotando, una cámara atravesando una escena
                o una imagen con luz de cine. Escribes el prompt, generas… y algo
                no encaja.
              </p>
              <p className="mt-4 text-[#beb9b0]" data-id="element-343" data-mp="fiu255kcnpdj">
                Cambias palabras. Añades “cinematográfico”. Copias otra
                instrucción. Aun así, cuesta saber qué ajustar y por qué.
              </p>
            </BibleReveal>
            <BibleReveal delay={0.12} data-id="element-344" data-mp="3f6sdv2plbk34">
              <aside className="bible-tilt rounded-r-lg border-l-2 border-[#e9c769] bg-[#141419] px-[30px] py-6 font-[Georgia,serif] text-[22px] italic leading-[1.5] md:text-[25px]" data-id="element-345" data-mp="3k052vdy6lswe">
                Una idea puede ser muy clara en tu cabeza y seguir siendo
                demasiado vaga en un prompt.
              </aside>
            </BibleReveal>
          </div>
        </section>

        {/* 02 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-346" data-mp="6tlf1gbv64i0">
          <div className="mx-auto grid w-[calc(100%-36px)] max-w-[1120px] items-start gap-7 md:w-[calc(100%-48px)] md:grid-cols-[1.2fr_1fr] md:gap-[65px]" data-id="element-347" data-mp="3oyop7fgot6pa">
            <BibleReveal data-id="element-348" data-mp="3tw84mip4fpit">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-349" data-mp="3tzm5tnm1tsoo">
                02 / La frustración
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-350" data-mp="2ijnpcyojk4df">
                Cada intento debería darte algo más que{' '}
                <em className="bible-em" data-id="element-351" data-mp="2a3gcd5wqw0dl">otro resultado distinto.</em>
              </h2>
              <p className="text-[#beb9b0]" data-id="element-352" data-mp="2623b794lkld0">
                Si cambias todo a la vez, resulta difícil identificar qué mejora
                la imagen: el encuadre, la iluminación, la referencia o la
                acción.
              </p>
              <p className="mt-4 text-[#beb9b0]" data-id="element-353" data-mp="1racj3lnfvpji">
                Y cuando encuentras un prompt atractivo, todavía queda la parte
                importante: adaptarlo a tu producto, a tu mensaje y a la historia
                que quieres contar.
              </p>
            </BibleReveal>
            <BibleReveal delay={0.12} data-id="element-354" data-mp="1w9p2fwf3qehc">
              <aside className="bible-tilt rounded-r-lg border-l-2 border-[#e995b3] bg-[#141419] px-[30px] py-6 font-[Georgia,serif] text-[22px] italic leading-[1.5] md:text-[25px]" data-id="element-355" data-mp="1w8mg81sq507r">
                El siguiente paso es aprender qué decisiones estás tomando cuando
                escribes una instrucción.
              </aside>
            </BibleReveal>
          </div>
        </section>

        {/* 03 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-356" data-mp="1lvz1vmxqes73">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-357" data-mp="1gut7zlsc4yvz">
            <BibleReveal data-id="element-358" data-mp="1bvzwu00itjyz">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-359" data-mp="1bwrs19q7hfoq">
                03 / El método
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-360" data-mp="13468hrer34yu">
                Empieza a pensar tu visual{' '}
                <em className="bible-em" data-id="element-361" data-mp="y64on49i31mb">antes de generarlo.</em>
              </h2>
              <p className="max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-362" data-mp="t7uv0y3fc92t">
                El material combina ejemplos de prompts con principios de
                composición y narrativa. Una base para elegir con intención,
                probar y ajustar.
              </p>
            </BibleReveal>

            <div className="mt-8 grid gap-3 md:grid-cols-3 md:gap-[18px]" style={{
            perspective: '1200px'
          }} data-id="element-363" data-mp="2vsnnpho83wjk">
              {[{
              step: '01 · DEFINE',
              title: 'La escena y su intención',
              text: 'Decide qué debe destacar, qué quieres comunicar y qué elemento hará especial la imagen.'
            }, {
              step: '02 · ESTRUCTURA',
              title: 'Las instrucciones',
              text: 'Especifica sujeto, entorno, luz y cámara. Para video, organiza la acción en una secuencia.'
            }, {
              step: '03 · ADAPTA',
              title: 'El ejemplo a tu idea',
              text: 'Usa las referencias del material, cambia las variables y evalúa qué necesita el siguiente intento.'
            }].map((item, index) => <motion.article key={item.step} initial={{
              opacity: 0,
              y: 28,
              rotateX: 8
            }} whileInView={{
              opacity: 1,
              y: 0,
              rotateX: 0
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.6,
              delay: index * 0.09,
              ease: [0.22, 1, 0.36, 1]
            }} className="bible-tilt rounded-xl border border-[#2c2a30] bg-[#141419] p-6" data-id="element-364" data-mp="1qcvhxo49bvi9" data-mpi={index}>
                  <b className="mb-[18px] block text-[12px] tracking-[0.1em] text-[#e9c769]" data-id="element-365" data-mp="13dpg6voyking">
                    {item.step}
                  </b>
                  <h3 className="bible-serif-tight text-[20px] leading-[1.35]" data-id="element-366" data-mp="1ha2rfn2wfnth">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-[15px] text-[#beb9b0]" data-id="element-367" data-mp="2sqsyt9j26loo">{item.text}</p>
                </motion.article>)}
            </div>

            <p className="mt-6 text-[13px] text-[#beb9b0]" data-id="element-368" data-mp="2nulshfmr3867">
              El proceso requiere práctica. Las herramientas de generación y
              edición se utilizan por separado.
            </p>
          </div>
        </section>

        {/* 04 */}
        <section id="materiales" className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-369" data-mp="ktsq0uoflic">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-370" data-mp="5jok3r6pmie2">
            <BibleReveal data-id="element-371" data-mp="ta0nqpux9syu">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-372" data-mp="tatye1x052m9">
                04 / Lo que recibes
              </p>
              <h2 className="bible-serif mb-6 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-373" data-mp="jjphgwnrn7os">
                Una biblioteca para{' '}
                <em className="bible-em" data-id="element-374" data-mp="og6940u6c46m">dar dirección a tu creatividad.</em>
              </h2>
              <p className="max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-375" data-mp="1c60gw3zmz2k0">
                Recibes cinco documentos de contenido y una guía de acceso a la
                comunidad: seis PDF en total, más acceso a Skool.
              </p>
            </BibleReveal>

            <BibleProducts data-id="element-376" data-mp="3jhqqd10paceh" />

            <p className="mt-6 text-[13px] text-[#beb9b0]" data-id="element-377" data-mp="3jhh0rejki79b">
              Material digital. No se envían libros físicos. Las suscripciones a
              herramientas de IA no están incluidas. Para trabajos comerciales,
              revisa también las condiciones de la herramienta y de los recursos
              que utilices.
            </p>
          </div>
        </section>

        {/* SOCIAL PROOF */}
        <section id="testimonios" className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-378" data-mp="73hr4uhbmept">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-379" data-mp="3th7uvf47uk8v">
            <BibleReveal data-id="element-380" data-mp="uqzfeg1dmuo1">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-381" data-mp="ur7nlumk1bsw">
                Lo que dicen quienes ya lo están usando
              </p>
              <h2 className="bible-serif mb-8 max-w-[800px] text-[clamp(28px,4vw,47px)]" data-id="element-382" data-mp="xbnknyrifpjd">
                Creadores que dejaron de{' '}
                <em className="bible-em" data-id="element-383" data-mp="12bjsk93bw147">improvisar cada prompt.</em>
              </h2>
            </BibleReveal>

            <BibleReveal delay={0.1} data-id="element-384" data-mp="1780dkuf8dzd2">
              <BibleTestimonials data-id="element-385" data-mp="1bb6rmo8l4uu3" />
            </BibleReveal>

            <p className="mt-5 text-[13px] text-[#beb9b0]" data-id="element-386" data-mp="1bcq7weu8r5vv">
              Comentarios compartidos por miembros de la comunidad. Los
              resultados dependen de la práctica, la herramienta y los ajustes de
              cada persona.
            </p>
          </div>
        </section>

        {/* 05 */}
        <section id="oferta" className="scroll-mt-7 border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-387" data-mp="1q0usjocutrha">
          <div className="mx-auto grid w-[calc(100%-36px)] max-w-[1120px] items-center gap-7 md:w-[calc(100%-48px)] md:grid-cols-2 md:gap-[45px]" data-id="element-388" data-mp="1z0r9t4wwzo2b">
            <BibleReveal data-id="element-389" data-mp="240m0b7cs2bmu">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-390" data-mp="23xrlbvcj9j0t">
                05 / Tu acceso
              </p>
              <h2 className="bible-serif mb-6 text-[clamp(28px,4vw,47px)]" data-id="element-391" data-mp="3w26o2m95mvbw">
                Dale una estructura
                <br data-id="element-392" data-mp="dofrw8b14vdu" />a tu <em className="bible-em" data-id="element-393" data-mp="doz212ufufhb">próxima idea.</em>
              </h2>
              <ul className="my-6 list-none p-0" data-id="element-394" data-mp="8wfryfuym2h9">
                {['Los seis PDF descritos arriba.', 'Ejemplos para adaptar a imágenes y videos.', 'Principios de composición y narrativa visual.', 'Acceso a la comunidad en Skool.', 'Siete días para revisar el material con garantía.'].map((item, index) => <motion.li key={item} initial={{
                opacity: 0,
                x: -16
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                amount: 0.6
              }} transition={{
                duration: 0.45,
                delay: index * 0.06
              }} className="flex gap-3.5 border-b border-[#2c2a30] py-3.5 text-[15px]" data-id="element-395" data-mp="rogsrnrao2tb" data-mpi={index}>
                    <span aria-hidden="true" className="text-[#e9c769]" data-id="element-396" data-mp="1dut2dvfico9e">
                      ✓
                    </span>
                    {item}
                  </motion.li>)}
              </ul>
            </BibleReveal>

            <BibleReveal delay={0.12} data-id="element-397" data-mp="q69uhh0dedhu">
              <div className="bible-tilt rounded-2xl border border-[#7b663b] bg-[linear-gradient(150deg,#30271688,#141419)] px-5 py-7 text-center md:p-[38px]" data-id="element-398" data-mp="q58jtdn9nt0n">
                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-399" data-mp="h5lg2l72eb4f">
                  Visual Disruption Bible 2.0 + complementos
                </p>
                <motion.p initial={{
                opacity: 0,
                scale: 0.92
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true,
                amount: 0.6
              }} transition={{
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
              }} className="my-4 font-[Georgia,serif] text-[76px] leading-none tracking-[-0.05em] text-[#e9c769] [text-shadow:0_0_36px_rgba(233,199,105,0.35)]" data-id="element-400" data-mp="l8qfgevulwou">
                  $11.99
                </motion.p>
                <p data-id="element-401" data-mp="tjf6cs79dlin">Un solo pago por el paquete y el acceso a Skool.</p>
                <a id={BIBLE_PRIMARY_CTA_ID} href={purchaseHref} onClick={handlePurchaseClick} className="bible-cta mt-4 w-full scroll-mt-[30vh]" data-id="element-402" data-mp="om5gxcjvd9ut">
                  Quiero acceder por $11.99 →
                </a>
                <p className="mt-3.5 text-[13px] text-[#beb9b0]" data-id="element-403" data-mp="an5vsevkfd3e">
                  Entrega digital · Garantía de 7 días
                </p>
                <p className="mt-3.5 text-[13px] text-[#beb9b0]" data-id="element-404" data-mp="250olx3n9nteo">
                  Herramientas de IA y edición por separado. Pueden requerir
                  pagos o créditos adicionales.
                </p>
                <p hidden={!noticeVisible} role="status" className="mt-3 text-[13px] text-[#e995b3]" data-id="element-405" data-mp="28je1o3aer6mc">
                  El enlace de compra aún no está disponible.
                </p>
              </div>
            </BibleReveal>
          </div>
        </section>

        {/* 06 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-406" data-mp="2m9hk0j662g6i">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[1120px] md:w-[calc(100%-48px)]" data-id="element-407" data-mp="1plbelu1f7jr6">
            <BibleReveal data-id="element-408" data-mp="1tmd95xke77mt">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-409" data-mp="1tnoazrua25ba">
                06 / Compra con tranquilidad
              </p>
              <div className="grid gap-6 rounded-xl border border-[#2c2a30] bg-[#141419] p-6 md:grid-cols-[70px_1fr] md:gap-[25px] md:p-[35px]" data-id="element-410" data-mp="23ksx5ro4i0s3">
                <div aria-hidden="true" className="grid h-[65px] w-[65px] place-items-center rounded-full border border-[#e9c769] font-[Georgia,serif] text-[30px] text-[#e9c769] shadow-[0_0_28px_rgba(233,199,105,0.25)]" data-id="element-411" data-mp="3a27pqanh838c">
                  7
                </div>
                <div data-id="element-412" data-mp="14efa5zgjiyyz">
                  <h2 className="bible-serif mb-4 text-[28px] md:text-[34px]" data-id="element-413" data-mp="14dx6ihrjtih1">
                    Tómate siete días para{' '}
                    <em className="bible-em" data-id="element-414" data-mp="19cqkebaqzbhq">revisarlo.</em>
                  </h2>
                  <p className="text-[#beb9b0]" data-id="element-415" data-mp="bqjff0aj7h4u">
                    Si el material no es para ti, solicita la devolución dentro
                    de los siete días posteriores a la compra. Te devolvemos lo
                    pagado por el producto, sin preguntas.
                  </p>
                  <p className="mt-3.5 text-[14px] text-[#beb9b0]" data-id="element-416" data-mp="ppj2w4mb5pzf">
                    Solicítala a través del canal de soporte indicado en tu
                    confirmación de compra.
                  </p>
                </div>
              </div>
            </BibleReveal>
          </div>
        </section>

        {/* 07 */}
        <section id="preguntas" className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-417" data-mp="3llyup3iyoe2s">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[860px] md:w-[calc(100%-48px)]" data-id="element-418" data-mp="3hn976i47lg5f">
            <BibleReveal data-id="element-419" data-mp="3cs27dle28vls">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-420" data-mp="37vbt93ltga30">
                07 / Preguntas frecuentes
              </p>
              <h2 className="bible-serif mb-6 text-[clamp(28px,4vw,47px)]" data-id="element-421" data-mp="32xabqn41gitn">
                Antes de <em className="bible-em" data-id="element-422" data-mp="2xvcl37tb6lqo">empezar.</em>
              </h2>
              <BibleFaq data-id="element-423" data-mp="2tuiychrlrczd" />
            </BibleReveal>
          </div>
        </section>

        {/* 08 */}
        <section className="border-t border-[#2c2a30] py-[50px] md:py-[76px]" data-id="element-424" data-mp="2owzm1negtaa2">
          <div className="mx-auto w-[calc(100%-36px)] max-w-[800px] text-center md:w-[calc(100%-48px)]" data-id="element-425" data-mp="s3o25othhbs4">
            <BibleReveal data-id="element-426" data-mp="n4bfb42m44pj">
              <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#e9c769]" data-id="element-427" data-mp="n6608idvvwtm">
                08 / Tu próxima creación
              </p>
              <h2 className="bible-serif mx-auto mb-6 text-[clamp(28px,4vw,47px)]" data-id="element-428" data-mp="1azxyk4mhs3li">
                La próxima vez que tengas una idea,
                <br data-id="element-429" data-mp="xa2vfnabwbfp" />
                <em className="bible-em" data-id="element-430" data-mp="xamex8fmn7vu">dale una dirección.</em>
              </h2>
              <p className="mx-auto max-w-[670px] text-[17px] text-[#beb9b0] md:text-[19px]" data-id="element-431" data-mp="128nxztd1z77b">
                Abre el material. Elige una escena. Adapta un ejemplo. Empieza a
                tomar decisiones sobre lo que quieres crear y lo que vas a
                pedirle a la IA.
              </p>
              <a href={secondaryHref} onClick={handleSecondaryClick} className="bible-cta mt-4" data-id="element-432" data-mp="1fyho0f0anxim">
                Quiero empezar — acceso por $11.99 →
              </a>
              <p className="mt-[17px] text-[13px] text-[#beb9b0]" data-id="element-433" data-mp="4mgsmh8xdatw">
                Seis PDF + acceso a Skool · Un solo pago · Garantía de 7 días
              </p>
              <p hidden={!noticeVisible} role="status" className="mt-3 text-[13px] text-[#e995b3]" data-id="element-434" data-mp="1yd21dyiyaop">
                El enlace de compra aún no está disponible.
              </p>
            </BibleReveal>
          </div>
        </section>
      </main>

      <footer className="relative z-10 border-t border-[#2c2a30] px-0 pb-[125px] pt-9 text-[12px] text-[#beb9b0] md:pb-[130px]" data-id="element-435" data-mp="61sxi6yuy4zt">
        <div className="mx-auto flex w-[calc(100%-36px)] max-w-[1120px] flex-wrap justify-between gap-5 md:w-[calc(100%-48px)]" data-id="element-436" data-mp="3eeqjl7gjv9x6">
          <span data-id="element-437" data-mp="3o7fmhdy1bfgw">© {new Date().getFullYear()} Start Launching Creatives</span>
          <div className="flex gap-5" data-id="element-438" data-mp="3jg63gw6zradz">
            {supportUrl ? <a id="support-link" href={supportUrl} data-id="element-439" data-mp="3jeuvslafdihl">
                Contacto
              </a> : null}
            {privacyUrl ? <a id="privacy-link" href={privacyUrl} data-id="element-440" data-mp="2qs1vg40y6l84">
                Privacidad
              </a> : null}
            {termsUrl ? <a id="terms-link" href={termsUrl} data-id="element-441" data-mp="34g26jilwdmm3">
                Términos
              </a> : null}
          </div>
          <span data-id="element-442" data-mp="3ecezufdj5ygb">
            Este sitio no está afiliado a Meta ni a las plataformas de IA
            mencionadas.
          </span>
        </div>
      </footer>

      <BibleLiveViewers data-id="element-443" data-mp="3j4ojxerys4ao" />
      <BibleSalesToast data-id="element-444" data-mp="3j4ye7ek1kxm6" />
      <BibleStickyBar href={secondaryHref} onClick={handleSecondaryClick} data-id="element-445" data-mp="3n4z01k9h0b39" />
    </div>;
}